import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import dropdown from "../../../assets/common/dropdown.svg";
import errorInfo from "../../../assets/common/errorInfo.svg";
import shield from "../../../assets/common/shield.svg";
import clear from "../../../assets/common/clear.svg";
import upload from "../../../assets/common/upload.svg";
import trash from "../../../assets/common/trash.svg";

import { toast } from "react-toastify";
import {
  Button,
  GenericDiv,
  RespFont,
  FlexRowBetween,
  DropOption,
  PlaceHolderImage,
  PopupForm,
  Input,
  Label,
} from "../../common/Style";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { addMany } from "../../../store/reducers/guestsReducer";
import { CFV, addAlpha } from "../../common/others/Functions";
import OWC from "./OWC";
let inputs = {};
let inputsErrors = {};
let multyChoise = {};

const AddIphone = (props) => {
  const { user } = useSelector((state) => state.authReducer);
  const defaultPreSms1 = `${user.brideFN + " " + user.brideLN} ו${
    user.groomFN + " " + user.groomLN
  } שמחים להזמינכם לחתונתם!`;
  const [doneB, setDoneB] = useState(true);
  const [isMultyChoiseChanged, setIsMultyChoiseChanged] = useState(false);
  const [arrC, setArrC] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [inviting, setInviting] = useState("");

  const [dis, setDis] = useState(true);
  const [contacts, setContacts] = useState([]);
  useEffect(() => {
    const supported = "contacts" in navigator && "ContactsManager" in window;
    if (supported) {
      setDis(false);
    }
  }, []);

  const add_del = (item) => {
    if (multyChoise[item._id] !== undefined) {
      delete multyChoise[item._id];
    } else multyChoise[item._id] = { tel: item.tel, name: item.name };
    setIsMultyChoiseChanged(!isMultyChoiseChanged);
  };

  let iPhoneArray = useMemo(() => {
    let ii = [];
    let checked, disabled;
    if (arrC !== null)
      for (let i = 0; i < arrC.length; i++) {
        checked =
          multyChoise[arrC[i]._id] !== undefined ||
          props.phones[arrC[i].tel] !== undefined;
        disabled = props.phones[arrC[i].tel] !== undefined;
        if (
          arrC[i].name !== undefined &&
          (searchText.length === 0 ||
            arrC[i].name?.toLowerCase().includes(searchText.toLowerCase()))
        )
          ii.push(
            <RespFont
              key={i}
              onClick={() => {
                // if (disabled) toast.warning("כבר קיים ברשימת האורחים");
                // else
                add_del({
                  _id: arrC[i]._id,
                  name: arrC[i].name,
                  tel: arrC[i].tel,
                });
              }}
              style={{
                width: "max-content",
                padding: "5px 8px",
                margin: "5px",
                cursor: "pointer",
                borderRadius: "2px",
                transition: "200ms",
                background: disabled
                  ? addAlpha("#7b96c4", 0.2)
                  : checked
                  ? addAlpha("#7b96c4", 0.5)
                  : "inherit",
              }}
            >
              {arrC[i].name}
            </RespFont>
            // </FlexRowBetween>
          );
      }
    return ii;
  }, [searchText, arrC, isMultyChoiseChanged]);

  // vcf iphone start
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const vcfText = event.target.result;
      const vcfData = parseVcf(vcfText);
      const cc = [];
      const sortedArray = [...vcfData.entries];
      sortedArray.sort(function (a, b) {
        var x = a["FN"];
        var y = b["FN"];

        if (typeof x == "string") {
          x = ("" + x).toLowerCase();
        }
        if (typeof y == "string") {
          y = ("" + y).toLowerCase();
        }

        return x < y ? -1 : x > y ? 1 : 0;
      });
      let tn = "";
      for (let i = 0; i < sortedArray.length; i++) {
        let key = Object.keys(sortedArray[i]).filter((x) => x.includes("TEL"));
        let t = sortedArray[i][key[0]];
        if (t !== undefined) {
          t = t.replaceAll(/[^\d]/g, "");
          if (t[0] === "9" && t[1] === "7" && t[2] === "2") t = t.substring(3);
          if (t[0] === "0") t = t.substring(1);
        }
        cc.push({
          _id: i,
          name: sortedArray[i]["FN"],
          tel: t,
        });
      }
      setArrC(cc);
    };
    reader.readAsText(file, "UTF-8");
  };
  const parseVcf = (vcfText) => {
    const lines = vcfText.split(/\r?\n/);
    const vcfData = {
      meta: {},
      entries: [],
    };
    let currentEntry = null;
    for (let line of lines) {
      if (line.startsWith("BEGIN:VCARD")) {
        currentEntry = {};
      } else if (line.startsWith("END:VCARD")) {
        vcfData.entries.push(currentEntry);
        currentEntry = null;
      } else if (currentEntry !== null) {
        const [key, value] = line.split(":");
        currentEntry[key] = value;
      } else if (line.startsWith("FN:")) {
        vcfData.meta.name = line.substring(3);
      } else if (line.startsWith("VERSION:")) {
        vcfData.meta.version = line.substring(8);
      }
    }
    return vcfData;
  };
  // vcf iphone end

  async function getContacts() {
    const props = ["name", "tel"];
    const opts = { multiple: true };
    try {
      const contacts = await navigator.contacts.select(props, opts);
      renderResults(contacts);
    } catch (ex) {
      alert(ex.toString());
    }
  }

  function renderResults(contacts) {
    const tempG = [];
    contacts.forEach((contact) => {
      let tempO = {};
      if (contact.name) tempO["name"] = contact.name[0];
      if (contact.tel) {
        let t = contact.tel[0];
        if (t[0] === "0") t = t.substring(1);
        t = t.replaceAll("-", "");
        t = t.replaceAll(/[^\d]/g, "");
        if (t[0] === "9" && t[1] === "7" && t[2] === "2") t = t.substring(3);
        tempO["tel"] = t;
      }
      tempG.push(tempO);
    });
    setContacts(tempG);
    setDoneB(false);
  }
  let height = window.screen.availHeight;
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [closeness, setCloseness] = useState("");
  const [flag, setFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [show, setShow] = useState(true);
  const [owc, setOwc] = useState("קשר");
  const [showDropOwc, setShowDropOwc] = useState(false);
  const width = window.screen.availWidth;
  const [animate, setAnimate] = useState(
    "animate__animated animate__heartBeat animate__infinite"
  );
  const handleOnSelect = (item) => {
    setCloseness(item.id);
  };
  const handleOnSearch = (string, results) => {
    setCloseness(string);
  };

  const digitOrNull = (value) =>
    parseInt(value) >= 0 ? parseInt(value) : null;

  const onSubmit = async (data) => {
    setChecked(false);
    let rows = [
      ["שם מלא", "טלפון", "קירבה", "מוזמנים", "אישרו", "מזמין", "קשר", "מספר"],
    ];
    let newOwc = "";
    if (
      user.eventType &&
      ((inviting?.length && owc === "קשר") ||
        (inviting?.length === 0 && owc !== "קשר"))
    )
      toast.warning("שדה המזמין והקשר באים ביחד - הכל או כלום");
    else if (closeness.length > 1) {
      newOwc = owc;
      for (let i = 0; i < contacts.length; i++) {
        if (inputs[i] !== false)
          rows.push([
            data[`${i}name`],
            data[`${i}phone`].length ? data[`${i}phone`] : null,
            closeness,
            digitOrNull(data[`${i}sum`]),
            digitOrNull(data[`${i}accept`]),
            inviting,
            newOwc === "קשר" ? "" : newOwc,
            i + 1,
          ]);
      }
      if (rows.length === 1) toast.warning("לא נבחרו רשומות להוספה");
      else {
        dispatch(addMany({ rows })).then((res) => {
          setChecked(true);
          if (!res.payload?.error) {
            toast.success("הפעולה בוצעה בהצלחה!!");
            setTimeout(function () {
              setLoading(false);
              multyChoise = {};
              inputs = {};
              setContacts([]);
              props.init();
            }, 2000);
          } else {
            multyChoise = {};
            setLoading(false);
            toast.error("לא כל הרשומות נטענו בהצלחה, ראו פירוט בכל שורה");

            for (let i = 0; i < contacts.length; i++) inputs[i] = false;
            for (let i = 0; i < res.payload?.error.length; i++) {
              inputs[res.payload?.error[i]["מספר"] - 1] = true;
              inputsErrors[res.payload?.error[i]["מספר"] - 1] =
                res.payload?.error[i]["סיבה"];
            }

            setFlag(!flag);
          }
        });
      }
    } else toast.warning("שדה קירבה לא יכול להיות פחות מ 2 תווים");
  };
  const handleSwitch = (e, i) => {
    inputs[i] = e;
    setFlag(!flag);
  };

  let guestsArray = useMemo(() => {
    let guests = [];
    for (let i = 0; i < contacts.length; i++) {
      guests.push(
        <div
          key={i}
          style={{
            display: checked && inputs[i] === false ? "none" : "flex",
            flexDirection: "column",
            width: "94%",
            margin: "0 auto",
            padding: "16px 18px",
            backgroundColor: "#f8f9fa",
            marginTop: "12px",
            borderRadius: "8px",
            paddingTop: "16px",
            border: "1px solid #e8e8e8",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
          }}
        >
          <FlexRowBetween style={{ marginTop: "10px" }}>
            <div style={{ position: "relative", width: "50%" }}>
              <Input
                style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                placeholder={"שם מלא"}
                type="text"
                defaultValue={contacts[i]["name"]}
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register(`${i}name`, {
                  required: true,
                  minLength: 2,
                  maxLength: 50,
                })}
              />
              {CFV(`${i}name`, "בין 2 ל 50 תווים", errors)}
            </div>
            <div style={{ position: "relative", width: "40%" }}>
              <Input
                style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                placeholder={"מס׳ נייד"}
                type="text"
                defaultValue={contacts[i]["tel"]}
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register(`${i}phone`, {
                  pattern: /^[0]{0,1}[5]{1}[0-9]{8}$/,
                })}
              />
              {CFV(`${i}phone`, "פורמט מספר פלאפון לא חוקי", errors)}
            </div>
          </FlexRowBetween>
          <FlexRowBetween style={{ alignItems: "flex-end", marginTop: "10px" }}>
            <div style={{ position: "relative", width: "30%" }}>
              <Input
                style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                placeholder={"כמות"}
                defaultValue={1}
                type="number"
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register(`${i}sum`, {
                  required: true,
                  min: 1,
                  max: props.acceptLimit,
                })}
              />
              {CFV(`${i}sum`, `מספר בין 1 ל ${props.acceptLimit}`, errors)}
            </div>
            <div style={{ position: "relative", width: "30%" }}>
              <Input
                style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                placeholder={"אישרו"}
                type="number"
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register(`${i}accept`, {
                  min: 0,
                  max: props.acceptLimit,
                })}
              />
              {CFV(`${i}accept`, `מספר בין 0 ל ${props.acceptLimit}`, errors)}
            </div>

            {checked && inputs[i] && (
              <OverlayTrigger
                placement={"bottom"}
                overlay={
                  <Tooltip>
                    {inputsErrors[i] !== undefined && inputsErrors[i] !== ""
                      ? inputsErrors[i]
                      : "רשומה זו נכנסה בהצלחה!"}
                  </Tooltip>
                }
              >
                <img
                  src={
                    inputsErrors[i] !== undefined && inputsErrors[i] !== ""
                      ? errorInfo
                      : shield
                  }
                  style={{ width: "30px" }}
                  className={animate}
                />
              </OverlayTrigger>
            )}
          </FlexRowBetween>
        </div>
      );
    }

    return [guests];
  }, [flag, contacts.length, contacts, errors]);

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      style={{ height: "min-content", maxHeight: `${height * 0.8}px` }}
    >
      <FlexRowBetween
        style={{
          width: "90%",
          margin: "10px auto",
          marginTop: "30px",
          alignItems: "flex-end",
        }}
      >
        <div
          className="relativeBox"
          style={{
            zIndex: "1",
            marginRight: "0",
            width: "65%",
          }}
        >
          <Label>קירבה</Label>
          <ReactSearchAutocomplete
            items={props.categories}
            onSelect={handleOnSelect}
            autoFocus
            onSearch={handleOnSearch}
            fuseOptions={{ minMatchCharLength: 1 }}
            maxResults={show ? 10 : 0}
            showNoResults={false}
            // placeholder="קירבה"
            styling={{
              searchIconMargin: "0 5px 0 10px",
              clearIconMargin: "4px 0 0 5px",
              borderRadius: "5px",
              width: "100%",
              height: "40px",
              fontFamily: "heb",
            }}
          />
        </div>
        <OverlayTrigger
          placement={"bottom"}
          overlay={
            <Tooltip>
              {show ? "הסתרת השלמות לחיפוש" : "הצגת השלמות לחיפוש"}
            </Tooltip>
          }
        >
          <div
            style={{
              backgroundColor: "#7b96c4",
              color: "#ffffff",
              padding: "10px 18px",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              fontSize: "14px",
              fontWeight: "400",
              fontFamily: "system-ui, -apple-system, sans-serif",
              boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
            }}
            onClick={() => setShow(!show)}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#6a87b3";
              e.currentTarget.style.boxShadow = "0 2px 6px rgba(123, 150, 196, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#7b96c4";
              e.currentTarget.style.boxShadow = "0 1px 3px rgba(123, 150, 196, 0.3)";
            }}
          >
            {show ? "הסתר" : "הצג"}
          </div>
        </OverlayTrigger>
      </FlexRowBetween>

      {user.eventType && (
        <FlexRowBetween
          style={{
            width: "90%",
            margin: "10px auto",
            alignItems: "flex-end",
          }}
        >
          <div style={{ position: "relative", width: "65%" }}>
            <div>
              <Label>המזמין</Label>
              <RespFont
                psize={"12px"}
                csize={"14px"}
                style={{ textAlign: "right" }}
              >
                (במידה ואלו מוזמנים של הזוג יש לדלג על שורה זו)
              </RespFont>
            </div>
            <Input onChange={(e) => setInviting(e.target.value)} type="text" />
          </div>
          <OverlayTrigger
            placement={"top"}
            overlay={<Tooltip>{"הקשר של בעל/ת השמחה למזמין"}</Tooltip>}
          >
            <div
              style={{
                backgroundColor: "#7b96c4",
                color: "#ffffff",
                padding: "10px 18px",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                fontSize: "14px",
                fontWeight: "400",
                fontFamily: "system-ui, -apple-system, sans-serif",
                boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginTop: "7px",
                position: "relative",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowDropOwc(!showDropOwc);
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#6a87b3";
                e.currentTarget.style.boxShadow = "0 2px 6px rgba(123, 150, 196, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#7b96c4";
                e.currentTarget.style.boxShadow = "0 1px 3px rgba(123, 150, 196, 0.3)";
              }}
            >
              <span>{owc}</span>
              <img
                src={dropdown}
                alt={"dropdown"}
                style={{ width: "20px", height: "20px", filter: "brightness(0) invert(1)" }}
              />
              {showDropOwc && (
                <OWC setOwc={setOwc} setShowDropOwc={setShowDropOwc} />
              )}
            </div>
          </OverlayTrigger>
        </FlexRowBetween>
      )}
      {user.eventType && (
        <FlexRowBetween
          style={{ width: "90%", margin: "0 auto", marginBottom: "20px" }}
        >
          <RespFont>
            {inviting !== "" && owc !== "קשר" ? (
              inviting +
              (owc[owc.length - 1] === "ם"
                ? " שמחים"
                : owc[owc.length - 1] === "ו"
                ? " שמח"
                : " שמחה") +
              " להזמינכם לחתונת " +
              owc +
              (owc.includes("ת") ? ` ${user.brideFN}.` : ` ${user.groomFN}.`)
            ) : (
              <>ברירת מחדל: {defaultPreSms1}</>
            )}
          </RespFont>
        </FlexRowBetween>
      )}
      {contacts.length === 0 && (
        <Button
          onClick={getContacts}
          disabled={dis}
          style={{
            backgroundColor: dis ? "#cccccc" : "#7b96c4",
            color: "#ffffff",
            border: "none",
            borderRadius: "8px",
            padding: "12px 24px",
            fontSize: "15px",
            fontWeight: "400",
            fontFamily: "system-ui, -apple-system, sans-serif",
            cursor: dis ? "not-allowed" : "pointer",
            transition: "all 0.2s ease",
            boxShadow: dis ? "none" : "0 1px 3px rgba(123, 150, 196, 0.3)",
            opacity: dis ? 0.6 : 1,
          }}
          onMouseEnter={(e) => {
            if (!dis) {
              e.currentTarget.style.backgroundColor = "#6a87b3";
              e.currentTarget.style.boxShadow = "0 2px 6px rgba(123, 150, 196, 0.4)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }
          }}
          onMouseLeave={(e) => {
            if (!dis) {
              e.currentTarget.style.backgroundColor = "#7b96c4";
              e.currentTarget.style.boxShadow = "0 1px 3px rgba(123, 150, 196, 0.3)";
              e.currentTarget.style.transform = "translateY(0)";
            }
          }}
        >
          {dis ? "מכשירי אנדרואיד - דפדפן כרום בלבד" : "ייבוא אנשי קשר"}
        </Button>
      )}
      {guestsArray[0]}
      <FlexRowBetween style={{ width: "90%", margin: "20px auto" }}>
        {contacts.length ? (
          <Button
            style={{
              margin: "0 auto",
              width: "50%",
              background: "#7b96c4",
              color: "#ffffff",
              border: "none",
              borderRadius: "8px",
              padding: "12px 24px",
              fontSize: "15px",
              fontWeight: "400",
              fontFamily: "system-ui, -apple-system, sans-serif",
              cursor: "pointer",
              transition: "all 0.2s ease",
              boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
            }}
            type="submit"
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#6a87b3";
              e.currentTarget.style.boxShadow = "0 2px 6px rgba(123, 150, 196, 0.4)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#7b96c4";
              e.currentTarget.style.boxShadow = "0 1px 3px rgba(123, 150, 196, 0.3)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            אישור
          </Button>
        ) : null}
      </FlexRowBetween>
      <div style={{ height: "10px" }}></div>
      {loading && <OpacityLoading />}
      {/* {doneB && (
        <FlexRowBetween
          style={{
            justifyContent: "space-between",
            width: "90%",
            margin: "0 auto",
            marginTop: "-30px",
            alignItems: "flex-end",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "110px",
              marginTop: "-10px",
            }}
          >
            <PlaceHolderImage
              onClick={() => setSearchText("")}
              fontSize={`27px`}
              top={`46.5px`}
              src={clear}
              alt="clear"
              style={{
                cursor: "pointer",
                border: "1px solid silver",
                padding: "4px",
                left: `5.5px`,
                borderRadius: "2px",
              }}
            />
            <Label>חיפוש</Label>
            <Input
              value={searchText}
              type="text"
              required={true}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <div style={{ direction: "ltr" }}>
            <label
              htmlFor="vcf-file-upload"
              className="custom-file-upload"
              style={{
                margin: "0px auto",
                direction: "rtl",
              }}
            >
              <img src={upload} style={{ width: "25px" }} />
            </label>
            <Input
              id="vcf-file-upload"
              type="file"
              onChange={handleFileUpload}
              accept=".vcf"
            />
          </div>
          <GenericDiv
            background={"#7b96c4"}
            style={{
              width: "min-content",
              padding: "9px 10px",
            }}
            onClick={() => {
              setContacts(Object.values(multyChoise));
              setDoneB(false);
            }}
          >
            סיום
          </GenericDiv>
        </FlexRowBetween>
      )} */}
    </PopupForm>
  );
};

export default AddIphone;
